import React, { Component } from "react";
import styles from "./Radio.scss";
import prettyCheckbox from "../../../assets/styles/pretty-checkbox/pretty-checkbox.scss";
import classnames from "classnames";

class Radio extends Component {
  _onChange = event => {
    this.props.input.onChange(event);
    if (this.props.handleChange) {
      this.props.handleChange(event);
    }
  };

  render() {
    const {
      formGroupClassName,
      text,
      input: { name, value, checked },
      selected
    } = this.props;

    return (
      <div>
        <div
          className={classnames(
            prettyCheckbox.pretty,
            prettyCheckbox["p-default"],
            prettyCheckbox["p-round"],
            prettyCheckbox["p-smooth"],
            formGroupClassName,
            styles.radio,
            { [styles.noMargin]: this.props.noMargin },
            { [styles.marginLeft]: this.props.marginLeft }
          )}
        >
          <input
            type="radio"
            name={name}
            value={value}
            checked={checked || selected}
            disabled={this.props.disabled}
            onChange={this._onChange}
          />

          <div
            className={classnames(
              prettyCheckbox.state,
              prettyCheckbox["p-primary-o"]
            )}
          >
            <label className={styles.text}>{text}</label>
          </div>
        </div>
      </div>
    );
  }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/common/radio/Radio.js